import { render } from "./event_register.vue?vue&type=template&id=25c78dc2&scoped=true"
import script from "./event_register.vue?vue&type=script&lang=js"
export * from "./event_register.vue?vue&type=script&lang=js"

import "./event_register.vue?vue&type=style&index=0&id=25c78dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c78dc2"]])

export default __exports__